var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.895,
    height: 150,
    viewBox: "0 0 157.895 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M153.947,110.526l3.947,3.947v31.579L153.947,150h-150L0,146.053V114.474l3.947-3.947Zm-127.3,7.895H17.763L14.8,121.382v17.763l2.961,2.961h8.882l2.961-2.961v-8.882H22.574v2.961h1.11v2.22l-.74.74h-1.48l-.74-.74V125.082l.74-.74h1.48l.74.74v2.22h5.921v-5.921Zm24.671,0H45.395v20.724l2.961,2.961h8.882l2.961-2.961V118.421H54.276v17.023l-.74.74h-1.48l-.74-.74Zm30.592,0H75.987v23.684h5.921Zm21.711,0H97.7v23.684h14.8v-5.921h-8.882Zm36.513,0H128.289v23.684h11.842l2.961-2.961V121.382Zm-3.7,5.921.74.74v10.362l-.74.74h-2.22V124.342ZM15.789,31.579,39.474,43.421V90.789L15.789,102.632,0,94.737V39.474Zm126.316,0,15.789,7.895v7.895l-15.789,7.895V47.368l-7.895,3.947V82.895l7.895,3.947V71.053l-3.947,1.974V65.132l19.737-9.868V94.737l-15.789,7.895L118.421,90.789V43.421ZM78.947,0l7.895,3.947V82.895l7.895-3.947V7.895l15.789,7.895V86.842L78.947,102.632,47.368,86.842V15.789L63.158,7.895V78.947l7.895,3.947V3.947ZM15.789,47.368V86.842l7.895-3.947V51.316Z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.9e02431b.svg";
export { ForwardRef as ReactComponent };